import React, { Suspense } from "react";
import { Switch, Route } from "react-router-dom";
import { connect } from "react-redux";

import ProtectedRoute from "./components/shared/protectedRoute/ProtectedRoute";
import NotFound from "./components/shared/errors/NotFound";
import ScrollToTopBtn from "./components/shared/scroll/ScrollToTopBtn";
import ErrorBoundary from "./components/shared/errorBoundary/ErrorBoundary";

import TermsForBuyer from "./components/buyer/termsForBuyer/TermsForBuyer";
import { PageLoading } from "./components/shared/message/Message";
import ErrorBoundary2 from "./components/shared/errorBoundary/ErrorBoundary2";

const Profile = React.lazy(() => import("./components/buyer/profile/Profile"));
const PayLater = React.lazy(() =>
  import("./components/shared/static/PayLater")
);
const FAQAnswer = React.lazy(() => import("./components/contact/FAQAnswer"));
const ProductDescription = React.lazy(() =>
  import("./components/buyer/productDescription/ProductDescription")
);
const SuccessPage = React.lazy(() =>
  import("./components/shared/success/SuccessPage")
);
const ForgotPassword = React.lazy(() =>
  import("./components/auth/signIn/ForgotPassword")
);
const SignIn = React.lazy(() => import("./components/auth/signIn/SignIn"));
const Register2 = React.lazy(() =>
  import("./components/auth/register/Register2")
);
const ReferAndEarn = React.lazy(() => import("./components/referAndEarn"));
const EmailVerification = React.lazy(() =>
  import("./components/buyer/email/EmailVerification")
);
const Banner = React.lazy(() => import("./components/buyer/banner/Banner"));

const DiwaliCampaign = React.lazy(() => import("./components/campaigns/DiwaliCampaign"));

const Checkout = React.lazy(() =>
  import("./components/buyer/checkout/Checkout")
);
const Outlet = React.lazy(() => import("./components/buyer/outlet/Outlet"));
const Credit = React.lazy(() => import("./components/buyer/credit/Credit"));
const Cart = React.lazy(() => import("./components/buyer/cart/Cart"));

const CreditLimit = React.lazy(() =>
  import("./components/buyer/credit/CreditLimit")
);
const Payment = React.lazy(() => import("./components/buyer/payment/Payment"));
const PaymentResult = React.lazy(() =>
  import("./components/buyer/paymentResult/PaymentResult")
);
const MilestoneBanner = React.lazy(() =>
  import("./components/buyer/home/MilestoneDetails")
);

const PaymentSuccess = React.lazy(() =>
  import("./components/buyer/paymentSuccess/PaymentSuccess")
);

const Order = React.lazy(() => import("./components/buyer/order/Order"));
const MxWeb = React.lazy(() => import("./components/auth/mxWeb/MXWeb"));
const OrderSuccess = React.lazy(() =>
  import("./components/buyer/orderSuccess/OrderSuccess")
);
const OrderDetail = React.lazy(() =>
  import("./components/buyer/orderDetail/OrderDetailV2")
);

const HpCredit = React.lazy(() =>
  import("./components/hpCredit/HpCredit")
);

const QRPayment =  React.lazy(() => import("./components/buyer/qrPayment/QRPayment"));

const HandleCatalog = React.lazy(() =>
  import("./components/handleCatalog/HandleCatalog")
);
const HandleSearch = React.lazy(() =>
  import("./components/handleSearch/HandleSearch")
);
const HandleHome = React.lazy(() =>
  import("./components/handleHome/HandleHome")
);

const Serviceable = React.lazy(() =>
  import("./components/serviceable/Serviceable")
);
const Contact = React.lazy(() => import("./components/contact/Contact"));
const ContactQueries = React.lazy(() =>
  import("./components/contact/ContactQueries")
);

const AcquisitionDetails = React.lazy(() =>
  import("./components/buyer/rewards/RewardsV2")
);

// const AcquisitionDetailsV2 = React.lazy(() =>
//   import("./components/buyer/rewards/RewardsV2")
// );

const DownloadDaApp = React.lazy(() =>
  import("./components/shared/download/DownloadDaApp")
);
const NpsUserRating = React.lazy(() =>
  import("./components/buyer/npsuserrating/NpsUserRating")
);
const RequestProduct = React.lazy(() =>
  import("./components/buyer/requestProduct/RequestProduct")
);

const HappyOnboarding = React.lazy(() =>
  import("./components/auth/register/HappyOnboarding")
);
const PastOrders = React.lazy(() =>
  import("./components/pastOrders/PastOrders")
);
const IosInstall = React.lazy(() => import("./components/shared/IosInstall"));
const Terms = React.lazy(() => import("./components/shared/terms/Terms"));
const WasteBuyerTerms = React.lazy(() =>
  import("./components/shared/terms/WasteBuyerTerms")
);

class RouteHandler extends React.Component {
  render() {
    return (
      <div
        style={{
          paddingTop: this.props.showAppInstallPrompt ? "60px" : "0px",
        }}
        className="site-content"
      >
        <ErrorBoundary>
          <ScrollToTopBtn />
          <TermsForBuyer />
          <Switch>
            <Route
              path="/success/:type"
              render={() => (
                <Suspense
                  fallback={
                    <React.Fragment>
                      <PageLoading />
                    </React.Fragment>
                  }
                >
                  <SuccessPage />
                </Suspense>
              )}
            />
            {/*auth routes*/}
            <ProtectedRoute
              path="/signIn/forgotPassword"
              forAuth={false}
              render={() => (
                <Suspense
                  fallback={
                    <React.Fragment>
                      <PageLoading />
                    </React.Fragment>
                  }
                >
                  <ForgotPassword />
                </Suspense>
              )}
            />
            <ProtectedRoute
              path="/signin"
              forAuth={false}
              render={() => (
                <Suspense
                  fallback={
                    <React.Fragment>
                      <PageLoading />
                    </React.Fragment>
                  }
                >
                  <SignIn />
                </Suspense>
              )}
            />
            <ProtectedRoute
              path="/register"
              forAuth={false}
              render={(props) => (
                <Suspense
                  fallback={
                    <React.Fragment>
                      <PageLoading />
                    </React.Fragment>
                  }
                >
                  <Register2 {...props} />
                </Suspense>
              )}
            />
            <ProtectedRoute
              forAuth={true}
              path="/referral"
              render={() => (
                <Suspense
                  fallback={
                    <React.Fragment>
                      <PageLoading />
                    </React.Fragment>
                  }
                >
                  <ReferAndEarn />
                </Suspense>
              )}
            />
            <Route
              path="/email-verification/:userId/:token"
              render={() => (
                <Suspense
                  fallback={
                    <React.Fragment>
                      <PageLoading />
                    </React.Fragment>
                  }
                >
                  <EmailVerification />
                </Suspense>
              )}
            />
            <ProtectedRoute
              forAuth={true}
              path="/buyer/banner"
              render={() => (
                <Suspense
                  fallback={
                    <React.Fragment>
                      <PageLoading />
                    </React.Fragment>
                  }
                >
                  <Banner />
                </Suspense>
              )}
            />
            <ProtectedRoute
              forAuth={true}
              path="/buyer/cart"
              render={() => (
                <Suspense
                  fallback={
                    <React.Fragment>
                      <PageLoading />
                    </React.Fragment>
                  }
                >
                  <Cart />
                </Suspense>
              )}
            />
            <ProtectedRoute
              forAuth={true}
              path="/buyer/outlet"
              render={() => (
                <Suspense
                  fallback={
                    <React.Fragment>
                      <PageLoading />
                    </React.Fragment>
                  }
                >
                  <Outlet />
                </Suspense>
              )}
            />
            <ProtectedRoute
              forAuth={true}
              path="/buyer/credit"
              render={() => (
                <Suspense
                  fallback={
                    <React.Fragment>
                      <PageLoading />
                    </React.Fragment>
                  }
                >
                  <Credit />
                </Suspense>
              )}
            />
            <ProtectedRoute
              forAuth={true}
              path="/buyer/credit-limit"
              render={(props) => (
                <Suspense
                  fallback={
                    <React.Fragment>
                      <PageLoading />
                    </React.Fragment>
                  }
                >
                 <HpCredit
                    {...props}
                  />
                </Suspense>
              )}
            />
            <ProtectedRoute
              forAuth={true}
              path="/buyer/payment/result"
              render={() => (
                <Suspense
                  fallback={
                    <React.Fragment>
                      <PageLoading />
                    </React.Fragment>
                  }
                >
                  <PaymentResult />
                </Suspense>
              )}
            />
            <ProtectedRoute
              forAuth={true}
              path="/buyer/payment/success"
              render={() => (
                <Suspense
                  fallback={
                    <React.Fragment>
                      <PageLoading />
                    </React.Fragment>
                  }
                >
                  <PaymentSuccess />
                </Suspense>
              )}
            />
                <ProtectedRoute
              forAuth={true}
              path="/milestoneDetails"
              render={() => (
                <Suspense
                  fallback={
                    <React.Fragment>
                      <PageLoading />
                    </React.Fragment>
                  }
                >
                  <MilestoneBanner />
                </Suspense>
              )}
            />
            <ProtectedRoute
              forAuth={true}
              path="/buyer/payment"
              render={() => (
                <Suspense
                  fallback={
                    <React.Fragment>
                      <PageLoading />
                    </React.Fragment>
                  }
                >
                  <Payment />
                </Suspense>
              )}
            />
            <ProtectedRoute
              forAuth={true}
              path="/invoices-detail/:orderNumber"
              render={() => (
                <Suspense
                  fallback={
                    <React.Fragment>
                      <PageLoading />
                    </React.Fragment>
                  }
                >
                  <QRPayment />
                </Suspense>
              )}
            />
            <ProtectedRoute
              forAuth={true}
              path="/buyer/checkout"
              render={() => (
                <Suspense
                  fallback={
                    <React.Fragment>
                      <PageLoading />
                    </React.Fragment>
                  }
                >
                  <Checkout />
                </Suspense>
              )}
            />
            <ProtectedRoute
              forAuth={true}
              path="/buyer/order/success"
              render={() => (
                <Suspense
                  fallback={
                    <React.Fragment>
                      <PageLoading />
                    </React.Fragment>
                  }
                >
                  <OrderSuccess />
                </Suspense>
              )}
            />
            <ProtectedRoute
              forAuth={true}
              path="/buyer/order/:orderNumber/:type"
              render={(props) => (
                <Suspense
                  fallback={
                    <React.Fragment>
                      <PageLoading />
                    </React.Fragment>
                  }
                >
                  <OrderDetail
                    {...props}
                    key={props.match.params.orderNumber}
                  />
                </Suspense>
              )}
            />
            <ProtectedRoute
              forAuth={true}
              path="/buyer/order/:orderID"
              render={(props) => (
                <Suspense
                  fallback={
                    <React.Fragment>
                      <PageLoading />
                    </React.Fragment>
                  }
                >
                  <OrderDetail {...props} key={props.match.params.orderID} />
                </Suspense>
              )}
            />
            <ProtectedRoute
              forAuth={true}
              path="/buyer/order"
              render={() => (
                <Suspense
                  fallback={
                    <React.Fragment>
                      <PageLoading />
                    </React.Fragment>
                  }
                >
                  <Order />
                </Suspense>
              )}
            />
            <ProtectedRoute
              forAuth={true}
              path="/buyer/profile"
              render={() => (
                <ErrorBoundary2
                  show
                  isPage
                  message="Profile couldn't be loaded"
                >
                  <Suspense
                    fallback={
                      <React.Fragment>
                        <PageLoading />
                      </React.Fragment>
                    }
                  >
                    <Profile />
                  </Suspense>
                </ErrorBoundary2>
              )}
            />
            {/*Common routes based on signedState*/}
            <Route
              path="/buyer/catalog/:categoryId/:subCategoryId"
              render={(props) => (
                <Suspense
                  fallback={
                    <React.Fragment>
                      <PageLoading />
                    </React.Fragment>
                  }
                >
                  <HandleCatalog {...props} path="catalog" />
                </Suspense>
              )}
            />
            <Route
              path="/buyer/catalog/:categoryName"
              render={(props) => (
                <Suspense
                  fallback={
                    <React.Fragment>
                      <PageLoading />
                    </React.Fragment>
                  }
                >
                  <HandleCatalog {...props} path="catalog" />
                </Suspense>
              )}
            />
            <Route
              path="/buyer/catalog"
              render={() => (
                <Suspense
                  fallback={
                    <React.Fragment>
                      <PageLoading />
                    </React.Fragment>
                  }
                >
                  <HandleCatalog path="catalog" />
                </Suspense>
              )}
            />
            <ProtectedRoute
              path="/buyer/query/:title/search"
              forAuth={true}
              key={"withQuery"}
              render={() => (
                <Suspense
                  fallback={
                    <React.Fragment>
                      <PageLoading />
                    </React.Fragment>
                  }
                >
                  <HandleSearch queryFromRoute={true} />
                </Suspense>
              )}
            />
            <ProtectedRoute
              path="/serviceable/:type"
              forAuth={true}
              render={() => (
                <Suspense
                  fallback={
                    <React.Fragment>
                      <PageLoading />
                    </React.Fragment>
                  }
                >
                  <Serviceable />
                </Suspense>
              )}
            />
            <ProtectedRoute
              path="/diwaliCampaign"
              forAuth={true}
              render={() => (
                <Suspense
                  fallback={
                    <React.Fragment>
                      <PageLoading />
                    </React.Fragment>
                  }
                >
                  <DiwaliCampaign />
                </Suspense>
              )}
            />
            <ProtectedRoute
              path="/contact/queries"
              forAuth={true}
              render={() => (
                <Suspense
                  fallback={
                    <React.Fragment>
                      <PageLoading />
                    </React.Fragment>
                  }
                >
                  <ContactQueries />
                </Suspense>
              )}
            />
            <ProtectedRoute
              path="/contact"
              forAuth={true}
              render={() => (
                <Suspense
                  fallback={
                    <React.Fragment>
                      <PageLoading />
                    </React.Fragment>
                  }
                >
                  <Contact />
                </Suspense>
              )}
            />
            <ProtectedRoute
              path="/faq"
              forAuth={true}
              render={() => (
                <ErrorBoundary2 show isPage message="FAQs couldn't be loaded">
                  <Suspense
                    fallback={
                      <React.Fragment>
                        <PageLoading />
                      </React.Fragment>
                    }
                  >
                    <FAQAnswer />
                  </Suspense>
                </ErrorBoundary2>
              )}
            />
            <ProtectedRoute
              path="/buyer/rewards"
              forAuth={true}
              render={() => (
                <Suspense
                  fallback={
                    <React.Fragment>
                      <PageLoading />
                    </React.Fragment>
                  }
                >
                  <AcquisitionDetails />
                </Suspense>
              )}
            />
            <Route
              path="/buyer/search"
              key={"withoutQuery"}
              render={() => (
                <Suspense
                  fallback={
                    <React.Fragment>
                      <PageLoading />
                    </React.Fragment>
                  }
                >
                  <HandleSearch />
                </Suspense>
              )}
            />
            <Route
              path="/ota/ios-install"
              render={() => (
                <ErrorBoundary2
                  show
                  isPage
                  message="Profile couldn't be loaded"
                >
                  <Suspense
                    fallback={
                      <React.Fragment>
                        <PageLoading />
                      </React.Fragment>
                    }
                  >
                    <IosInstall />
                  </Suspense>
                </ErrorBoundary2>
              )}
            />
            <Route
              path="/paylater"
              render={() => (
                <ErrorBoundary2
                  show
                  isPage
                  message="Profile couldn't be loaded"
                >
                  <Suspense
                    fallback={
                      <React.Fragment>
                        <PageLoading />
                      </React.Fragment>
                    }
                  >
                    <PayLater />
                  </Suspense>
                </ErrorBoundary2>
              )}
            />

            <Route
              path="/buyer/past-orders/:date"
              render={() => (
                <Suspense
                  fallback={
                    <React.Fragment>
                      <PageLoading />
                    </React.Fragment>
                  }
                >
                  <PastOrders />
                </Suspense>
              )}
            />

            <Route
              path="/buyer/past-orders"
              render={() => (
                <Suspense
                  fallback={
                    <React.Fragment>
                      <PageLoading />
                    </React.Fragment>
                  }
                >
                  <PastOrders />
                </Suspense>
              )}
            />

            <Route
              path="/request-product"
              render={() => (
                <Suspense
                  fallback={
                    <React.Fragment>
                      <PageLoading />
                    </React.Fragment>
                  }
                >
                  <RequestProduct />
                </Suspense>
              )}
            />

            {/*public routes*/}
            <Route
              path="/buyerterms"
              render={() => (
                <Suspense
                  fallback={
                    <React.Fragment>
                      <PageLoading />
                    </React.Fragment>
                  }
                >
                  <Terms />
                </Suspense>
              )}
            />
            <Route
              path="/wastebuyerterms"
              render={() => (
                <Suspense
                  fallback={
                    <React.Fragment>
                      <PageLoading />
                    </React.Fragment>
                  }
                >
                  <WasteBuyerTerms />
                </Suspense>
              )}
            />
            <ProtectedRoute
              forAuth={true}
              forCombineAuth={true}
              path="/"
              exact={true}
              render={(props) => (
                <Suspense
                  fallback={
                    <React.Fragment>
                      <PageLoading />
                    </React.Fragment>
                  }
                >
                  <HandleHome {...props} />
                </Suspense>
              )}
            />
            <Route
              path="/zomato/onboarding/"
              signOutFirst={true}
              forAuth={true}
              render={(props) => (
                <Suspense
                  fallback={
                    <React.Fragment>
                      <PageLoading />
                    </React.Fragment>
                  }
                >
                  <HappyOnboarding {...props} />
                </Suspense>
              )}
            />

            <Route
              path="/partnerweb/onboarding/"
              signOutFirst={true}
              forAuth={true}
              render={(props) => (
                <Suspense
                  fallback={
                    <React.Fragment>
                      <PageLoading />
                    </React.Fragment>
                  }
                >
                  <MxWeb {...props}/>
                </Suspense>
              )}
            />
            <Route
              path="/downloads/apk/:appType"
              render={(props) => (
                <Suspense
                  fallback={
                    <React.Fragment>
                      <PageLoading />
                    </React.Fragment>
                  }
                >
                  <DownloadDaApp {...props} />
                </Suspense>
              )}
            />

            <Route
              path="/npsuserrating/:rating/:token"
              render={(props) => (
                <Suspense
                  fallback={
                    <React.Fragment>
                      <PageLoading />
                    </React.Fragment>
                  }
                >
                  <NpsUserRating {...props} />
                </Suspense>
              )}
            />

            <ProtectedRoute
              forAuth={true}
              path="/buyer/product-detail/:id"
              render={(props) => (
                <ErrorBoundary2
                  show
                  isPage
                  message="Product detail couldn't be loaded"
                >
                  <Suspense
                    fallback={
                      <React.Fragment>
                        <PageLoading />
                      </React.Fragment>
                    }
                  >
                    <ProductDescription {...props} />
                  </Suspense>
                </ErrorBoundary2>
              )}
            />

            <Route render={() => <NotFound />} />
          </Switch>
        </ErrorBoundary>
      </div>
    );
  }
}
export default connect((state) => ({
  showAppInstallPrompt: state.user.showAppInstallPrompt,
}))(RouteHandler);
